import { Routes } from '@angular/router';
import { Segments } from './shared/constants/routes/segments.constant';
import { localeBootstrapGuard } from './shared/routing/guards/locale-bootstrap.guard';
import { rootRedirectGuard } from './shared/routing/guards/root-redirect.guard';
import { stateBootstrapGuard } from './shared/routing/guards/state-bootstrap.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [rootRedirectGuard],
    pathMatch: 'full',
    children: [],
  },
  {
    path: Segments.locale,
    canActivate: [localeBootstrapGuard, stateBootstrapGuard],
    loadChildren: () =>
      import('./features/root/root.routes').then(
        (m: typeof import('./features/root/root.routes')) => m.routes
      ),
  },
];
